export class ValidationError {
  source: string;
  errors: string[];

  constructor(source: string, errors: string[]) {
    this.source = source;
    this.errors = errors;
  }
}